import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { forwardRef as B } from "react";
import { c as y } from "../index-DA_5Gdu8.js";
import N from "./Button.styled.js";
import j from "./LoadingCircle.js";
import { ButtonIcon as i } from "./ButtonIcon.js";
const d = B(
  ({
    appearance: o = "solid",
    children: r,
    classes: m,
    disabled: p = !1,
    intent: n = "prominent",
    loading: f = !1,
    size: a = "48",
    endIcon: e = !1,
    startIcon: u = !1,
    ...s
  }, x) => {
    const c = { appearance: o, intent: n, loading: f, size: a, ...s };
    return /* @__PURE__ */ l(
      N,
      {
        "aria-disabled": f || p,
        classes: { ...m, text: void 0 },
        disabled: f || p,
        intent: n,
        ref: x,
        endIcon: e && /* @__PURE__ */ t(i, { icon: e, size: a }),
        startIcon: u && /* @__PURE__ */ t(i, { icon: u, size: a }),
        ...c,
        children: [
          f && /* @__PURE__ */ t(j, { appearance: o, intent: n, size: a }),
          r && /* @__PURE__ */ t("span", { className: y("Thr-Button-Text", m == null ? void 0 : m.text), children: r })
        ]
      }
    );
  }
);
d.displayName = "BaseButton";
const T = B(
  (o, r) => /* @__PURE__ */ t(d, { ...o, ref: r })
);
T.displayName = "Button";
export {
  T as default
};
//# sourceMappingURL=Button.js.map
